import React, { FunctionComponent } from 'react';

type SummaryFieldValueProps = {
  children?: React.ReactNode;
  'data-test'?: string;
};

const SummaryFieldValue: FunctionComponent<SummaryFieldValueProps> = (props) => {
  const { children, ...restProps } = props;

  return (
    <div className="section__content__field-value" {...restProps}>
      {children}
    </div>
  );
};

export default SummaryFieldValue;
